import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueUeditorWrap from '@/components/vue-ueditor-wrap.vue';
export default {
  name: 'QuestionPrevSet',
  props: {
    showType: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      /**
       * UEditor 简单版样式
       */
      UEditorSampleConfig: {
        initialFrameHeight: 350,
        toolbars: [['fullscreen', 'source', '|', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'forecolor', 'backcolor', '|', 'paragraph', 'fontfamily', 'fontsize', '|']]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  components: {
    'vue-ueditor-wrap': VueUeditorWrap
  },
  methods: {
    /**
     * 文件上传成功时的处理函数
     */
    successFile: function successFile(response, file, fileList, type, index) {
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = "";
      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });
      file.url = that.GLOBAL.getFileServeUrl() + downAddress;

      if (type == 0) {
        this.value.prevPageArr[index].defaultImg = fileList;
      } else if (type == 1) {
        this.value.prevPageArr[index].defaultRecord = fileList;
      }
    },

    /**
     * 文件删除时的处理函数
     */
    removeFile: function removeFile(file, fileList, type, index) {
      var that = this;
      var toHtId = "";
      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });

      if (type == 0) {
        this.value.prevPageArr[index].defaultImg = fileList;
      } else if (type == 1) {
        this.value.prevPageArr[index].defaultRecord = fileList;
      }
    },

    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile: function exceedFile(files, fileList) {
      this.$message({
        message: '最大文件上传个数为:' + 1 + ",不可超出!",
        type: 'warning'
      });
    },

    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName: function getFileTypeByName(name) {
      var fileType = 'image';

      if (name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0) {
        fileType = "image";
      } else if (name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
        fileType = "video";
      } else if (name.indexOf(".mp3") > 0) {
        fileType = "audio";
      }

      return fileType;
    },

    /**
     * 点击新增一个 前置页面设置
     */
    clickAddPrevPage: function clickAddPrevPage() {
      if (!this.value.prevPageArr) {
        this.$set(this.value, "prevPageArr", []);
      }

      this.$set(this.value, "ifShow", "1");
      this.value.prevPageArr.push({});
    },

    /**
     * 删除前置页面
     */
    clickDeletePrevPage: function clickDeletePrevPage(index) {
      this.value.prevPageArr.splice(index, 1);
    },

    /**
     * 上移子表格数据
     */
    toUpChildOne: function toUpChildOne(index) {
      if (index == 0) {
        var tmpOne = this.value.prevPageArr.splice(index, 1);
        this.value.prevPageArr.push(tmpOne[0]);
      } else {
        var targetIndex = index - 1;
        this.value.prevPageArr[index] = this.value.prevPageArr.splice(targetIndex, 1, this.value.prevPageArr[index])[0];
      }

      this.$forceUpdate();
    },

    /**
     * 下移子表格数据
     */
    toDownChildOne: function toDownChildOne(index) {
      if (index + 1 == this.value.prevPageArr.length) {
        var tmpOne = this.value.prevPageArr.splice(index, 1);
        this.value.prevPageArr.unshift(tmpOne[0]);
      } else {
        var targetIndex = index + 1;
        this.value.prevPageArr[index] = this.value.prevPageArr.splice(targetIndex, 1, this.value.prevPageArr[index])[0];
      }

      this.$forceUpdate();
    }
  }
};